import LogsTask from './LogsTask';

export default LogsTask;
